"use client";

import React, { FC } from "react";
import ReactHtmlParser from "react-html-parser";
import camelCase from "lodash/camelCase";

import { useAuth0V2 } from "@stadium/services/auth0";
import { useJuneSoComponentContext } from "@stadium/services/june-analytics";
import { useConfig } from "@stadium/hooks/lib/use-config";

import { getBookACallCtaText } from "@stadium/shared/src/selectors/book-a-call";

import { ExternalButton } from "@sharedComponents/buttons";
import OfferingTile from "@components/widgets/offerings-section/offering-tile";

import { BOOK_A_CALL, OFFERINGS_PATH } from "@constants/routes";
import { OFFERINGS_TYPE } from "@constants/offerings";

import styles from "./main.module.scss";
interface DefaultObjType {
  [key: string]: any;
}

type OfferingsSectionProps = {
  data: any;
};

const defaultObj: DefaultObjType = {};

const OPTIONS_CLASS_MAPPING = {
  shops: styles.offeringsShops,
  snackBoxes: styles.offeringsSnackBoxes,
  inPersonSnacks: styles.offeringsInPersonSnacks,
  recognitionPrograms: styles.offeringsRecognitionPrograms,
  sendItems: styles.offeringsSendItems,
  bulkSwag: styles.offeringsBulkSwag,
  swagKitsChoices: styles.offeringsSwagKitsChoices,
  swagStorage: styles.offeringsSwagStorage,
  automatedGifting: styles.offeringsAutomatedGifting,
  onDemandSwag: styles.offeringsOnDemandSwag,
};

const OfferingsSection: FC<OfferingsSectionProps> = ({ data }) => {
  const { jsonContent } = data || defaultObj;
  const { rte_content = "" } = (jsonContent && JSON.parse(jsonContent)) || defaultObj;
  const { isAuthenticated } = useAuth0V2();
  const { componentName } = useJuneSoComponentContext();
  const formattedComponentName = componentName ? `${componentName}-offerings-section` : "";
  const bookACallCtaText = useConfig(getBookACallCtaText);

  return (
    <div className={styles.solutionContainer}>
      <div className={styles.solutionHeaderContainer}>
        {rte_content && ReactHtmlParser(rte_content)}
      </div>
      <div className={styles.offeringSection}>
        {OFFERINGS_TYPE({ isAuthenticated }).map((offeringsData) => {
          const optionClassName = OPTIONS_CLASS_MAPPING[camelCase(offeringsData.key)];
          return (
            <OfferingTile
              optionClassName={optionClassName}
              {...offeringsData}
              key={offeringsData.key}
            />
          );
        })}
      </div>
      <ExternalButton
        className={styles.offeringBtn}
        href={OFFERINGS_PATH}
        styleType="primary"
        analytics={{
          componentName: formattedComponentName,
          target: "get-started",
        }}
        title="Get Started"
      >
        GET STARTED
      </ExternalButton>
      <div className={styles.offeringsFooterText}>
        Have multiple use cases?{" "}
        <ExternalButton
          href={BOOK_A_CALL}
          target="_blank"
          className={styles.expertButton}
          analytics={{
            componentName: formattedComponentName,
            target: "talk-to-sales",
          }}
          title={bookACallCtaText}
        >
          {bookACallCtaText}
        </ExternalButton>{" "}
        for guided setup.
      </div>
    </div>
  );
};

export default OfferingsSection;
